import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { useEmailTooltip } from '../../context/EmailTooltipContext';

const EmailTooltipMAIQ: React.FC = () => {
  const { tooltipState } = useEmailTooltip();
  const { isVisible, email, position } = tooltipState;

  if (!isVisible) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        top: position.y + 20,
        left: position.x,
        transform: 'translateX(-50%)',
        width: '320px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        zIndex: 9999,
        animation: 'tooltipFadeIn 0.2s ease',
        '@keyframes tooltipFadeIn': {
          '0%': {
            opacity: 0,
            transform: 'translateX(-50%) translateY(10px)',
          },
          '100%': {
            opacity: 1,
            transform: 'translateX(-50%) translateY(0)',
          },
        },
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: '-8px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '8px solid transparent',
          borderRight: '8px solid transparent',
          borderBottom: '8px solid #fff',
        },
      }}
    >
      <Box sx={{ 
        p: 1.5, 
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #eee',
        display: 'flex',
        alignItems: 'center',
        gap: 0.75
      }}>
        <EmailIcon sx={{ color: '#666', fontSize: '1rem' }} />
        <Typography variant="caption" sx={{ color: '#444', fontWeight: 600 }}>
          Message Preview
        </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        <Typography
          variant="body2"
          sx={{
            color: '#333',
            fontSize: '0.85rem',
            lineHeight: 1.5,
            whiteSpace: 'pre-wrap',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          }}
        >
          {email}
        </Typography>
      </Box>
    </Paper>
  );
};

export default EmailTooltipMAIQ; 